export default class Routes {
  //
  // Static routes
  //
  public static WorkPage = "/work";
}